export const DEFAULT_LAYOUT = 'default';
export const API_URL = process.env.API_URL;
export const APP_URL = process.env.APP_URL;



// WEBPACK FOOTER //
// ./src/constants/default.js